import React from 'react';
import classnames from 'classnames';
import Element from '../../element';
import MenuListItem from './item';
import styles from './menu.module.scss';

interface IProps {
    className?: string;
    title?: string;
    children: React.ReactNode;
}

function MenuList(props: IProps) {
    const { className, title, children, ...rest } = props;
    return (
        <>
            {title && <p className={styles['menu-label']}>{title}</p>}
            <Element
                renderAs="ul"
                className={classnames(styles['menu-list'], className)}
                {...rest}
            >
                {children}
            </Element>
        </>
    );
}

MenuList.Item = MenuListItem;

export default MenuList;
